import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import createRootReducer from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

const reducer = createRootReducer();

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false })
      .concat(sagaMiddleware),
  devTools: !!import.meta.env.DEV,
});

if (import.meta.env.DEV) {
  (window as any).store = store;
}

sagaMiddleware.run(rootSaga);

export default store;
